import { lazy, Suspense } from "react";

const TawkToChat = lazy(() => import("@/components/TawkToChat"));
const MatomoAnalytics = lazy(() => import("@/components/MatomoAnalytics"));
const GoogleAnalytics = lazy(() => import("@/components/GoogleAnalytics"));

export default function Analytics() {
  return (
    <Suspense fallback={null}>
      <TawkToChat />
      <MatomoAnalytics />
      <GoogleAnalytics />
    </Suspense>
  );
}
